"use client";

import { useEffect } from "react";

export function useNoZoom(active: boolean) {
  useEffect(() => {
    if (!active) return;
    const preventGesture = (event: Event) => {
      if (event.cancelable) event.preventDefault();
    };
    const preventMultiTouchMove = (event: TouchEvent) => {
      if (event.touches.length > 1 && event.cancelable) {
        event.preventDefault();
      }
    };
    const preventDblClick = (event: Event) => {
      if (event.cancelable) event.preventDefault();
    };

    document.addEventListener("gesturestart", preventGesture, { passive: false });
    document.addEventListener("gesturechange", preventGesture, { passive: false });
    document.addEventListener("gestureend", preventGesture, { passive: false });
    document.addEventListener("touchmove", preventMultiTouchMove, { passive: false });
    document.addEventListener("dblclick", preventDblClick, { passive: false });

    return () => {
      document.removeEventListener("gesturestart", preventGesture);
      document.removeEventListener("gesturechange", preventGesture);
      document.removeEventListener("gestureend", preventGesture);
      document.removeEventListener("touchmove", preventMultiTouchMove);
      document.removeEventListener("dblclick", preventDblClick);
    };
  }, [active]);
}
